wbApp.controller('UsersStudentsCtrl', ['$scope', '$modal', '$translate', '$filter', 'studentSvc', 'gridSortSvc',
function ($scope, $modal, $translate, $filter, studentSvc, gridSortSvc) {

    $scope.$on('userSelectionChanged', function (e, newlySelectedUser) {
        if (newlySelectedUser) {
            if (!$scope.user || ($scope.user.id !== newlySelectedUser.id)) {
                $scope.selectedUserStudents = studentSvc.getAllByUserIDAsync(newlySelectedUser.id);
                
            }
        }
        else {
            $scope.selectedUserStudents = [];
        }

        $scope.user = newlySelectedUser;
    });

    $scope.selectedUserStudents = [];
    $scope.user = {};

    $scope.studentsGridSettings = {
        name: 'students',
        columns: [
            {
                dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '180', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName2(data, 'fullName') }
            },
            { dataField: 'adminNotes', caption: $translate.instant('TXT_LBL_NOTE'), dataType: 'string' },
            { dataField: 'age', caption: $translate.instant("TXT_LBL_AGE"), dataType: 'string', width: '70px' },
            {
                dataField: 'gender',
                caption: $translate.instant('TXT_LBL_GENDER'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('gender')(rowData.gender);
                },
                width: '70px'
            },
            { dataField: 'birthday', caption: $translate.instant("TXT_LAB_BIRTHDAY"), dataType: 'date', format: { date: 'short' }, width: '100px' },
        ],
        shouldDisableAdd: function () { return !$scope.user; },
    };

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.selectedUserStudents;
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.collection = $scope.selectedUserStudents;
            detailDialogPromise.$scope.model = studentSvc.createNew($scope.user);
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        studentSvc.remove(data, null, $scope.selectedUserStudents);
    }

    var detailDialogPromise = $modal({
        templateUrl: 'users/students/students-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
